<div class="container-fluid flex flex-col h-full">
  <div class="bg-gradient-to-b from-transparent to-white flex-grow">
    <mat-drawer-container class="h-full min-h-[calc(100dvh-72px)]" autosize>
      <mat-drawer [mode]="'over'" #drawer class="md:min-w-[800px]">
        <div class="p-4 md:p-6">
          <!-- Back button row -->
          <div class="mb-4 sticky top-2 z-[999]">
            <button mat-icon-button (click)="drawer.close()"
              class="!text-white !bg-[#212529] hover:!bg-[#2c3238] transition-colors !flex !items-center !justify-center">
              <mat-icon>arrow_back</mat-icon>
            </button>
          </div>
          @switch(sidenavType()) {
          @case('details') {
          <app-details [job]="selected_job()" (close)="drawer.close()"
            (addCandidate)="sidenavType.set('add-candidate')"></app-details>
          }
          @case('add-candidate') {
          <app-create [jobID]="selected_job()?.id" [showCandidateForm]="true" (closeDrawer)="openDrawer(selected_job())"></app-create>
          }
          @case('add-job') {
          <app-create [showCandidateForm]="false" (closeDrawer)="drawer.close();loadJobs()"></app-create>
          }
          }
        </div>
      </mat-drawer>

      <div class="p-4 md:p-6">
        <div class="flex justify-between items-center mt-4 mb-6">
          <h1 class="text-3xl font-bold text-gray-800">Job Listings</h1>
          <button mat-button color="primary" (click)="sidenavType.set('add-job');drawer.open()">
            <mat-icon>add</mat-icon>
            Add Job
          </button>
        </div>

        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          @if (loading()) {
          @for(item of [1,2,3,4,5];track item) {
          <mat-card class="!bg-white shadow-md rounded-xl border border-gray-100 overflow-hidden min-h-[200px]">
            <!-- Header Skeleton -->
            <mat-card-header>
              <mat-card-title>
                <div class="h-7 w-48 bg-gray-200 rounded animate-pulse"></div>
              </mat-card-title>
            </mat-card-header>

            <mat-card-content>
              <!-- Description Skeleton -->
              <div class="my-2 space-y-2">
                <div class="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                <div class="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                <div class="h-4 bg-gray-200 rounded w-1/2 animate-pulse"></div>
              </div>

              <!-- Candidates Title Skeleton -->
              <!-- <div class="my-4">
                  <div class="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
                </div> -->

              <!-- Chips Skeleton -->
              <!-- <div class="flex flex-wrap gap-2">
                  @for (item of [1,2,3]; track item) {
                  <div class="h-8 w-24 bg-gray-200 rounded-full animate-pulse"></div>
                  }
                </div> -->
            </mat-card-content>

            <!-- Actions Skeleton -->
            <mat-card-actions class="flex justify-end gap-1 mt-auto">
              <div class="h-9 w-32 bg-gray-200 rounded animate-pulse"></div>
              <div class="h-9 w-32 bg-gray-200 rounded animate-pulse"></div>
            </mat-card-actions>
          </mat-card>
          }
          } @else {
          @for (job of jobs(); track job.id) {
          @defer {
          <app-job-card [loaders]="loaders" (openDrawer)="openDrawer($event)" [job]="job"></app-job-card>
          } @loading {
          <mat-card class="!bg-white shadow-md rounded-xl border border-gray-100 overflow-hidden min-h-[200px] animate-pulse">
            <mat-card-header>
              <mat-card-title>
                <div class="h-7 w-48 bg-gray-200 rounded"></div>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="my-2 space-y-2">
                <div class="h-4 bg-gray-200 rounded w-full"></div>
                <div class="h-4 bg-gray-200 rounded w-3/4"></div>
              </div>
            </mat-card-content>
          </mat-card>
          } @error {
          <mat-card class="!bg-white shadow-md rounded-xl border border-red-200 overflow-hidden min-h-[200px]">
            <mat-card-content class="flex flex-col items-center justify-center h-full py-8">
              <mat-icon class="text-4xl text-red-400 mb-2">error_outline</mat-icon>
              <p class="text-gray-600 mb-2">Failed to load job card</p>
              <p class="text-sm text-gray-500">{{ job.title }}</p>
            </mat-card-content>
          </mat-card>
          }
          } @empty {
          <div class="text-center py-12 bg-gray-50 rounded-lg col-span-3">
            <mat-icon class="text-6xl text-gray-400 mb-4">list_alt</mat-icon>
            <p class="text-xl text-gray-600">No jobs available. Publish your first job!</p>
          </div>
          }
          }
        </div>
      </div>

    </mat-drawer-container>
  </div>

</div>
